export default {
  lightText: '#8F919E',
  darkText: '#4E5D6A',
  bgGray: '#f3f3f3',
};
